var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activities"},[_c('ul',_vm._l((_vm.activites),function(a,i){return _c('activity',{key:i,attrs:{"activity-uid":a}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }